/** チャンネル内に保持する(channel_type='FILE'時)ストリームのデータタイプ */
export type FileStreamDataType = 'IMAGE' | 'VIDEO';
export const FileStreamDataTypes: FileStreamDataType[] = ['IMAGE', 'VIDEO'];
export function convertFileStreamDataType(s?: string, undef?: boolean) {
  for (const v of FileStreamDataTypes) if (v === s) return s;
  return undef ? undefined : FileStreamDataTypes[0];
}
